import { lessonList, resetLessonList } from "constants/lesson";

const initialState = {
  lessonList: {},
};

const lesson = (state = initialState, action) => {
  switch (action.type) {
    case lessonList:
      return { ...state, lessonList: action.payload };

    case resetLessonList:
      return { ...state, lessonList: {} };

    default:
      return state;
  }
};

export default lesson;